import { Component, OnInit } from '@angular/core';
import { AlertService, ComponentsStoreService, IAlertType } from '../../../_shared/services';
import { ClrDatagridModule, ClrDatagridSortOrder, ClrIconModule } from '@clr/angular';
import { Components } from '../../../_shared/interfaces';
import { ActivatedRoute, RouterLink } from "@angular/router";
import { CurrencyPipe, NgIf } from "@angular/common";
import { ClarityIcons, cogIcon, nodeIcon, twoWayArrowsIcon} from "@cds/core/icon";
import { ComponentSubnavComponent } from "../component-subnav/component-subnav.component";

@Component({
  selector: 'app-component',
  standalone: true,
  imports: [
    ClrDatagridModule,
    RouterLink,
    ClrIconModule,
    NgIf,
    CurrencyPipe,
    ComponentSubnavComponent
  ],
  templateUrl: './component.component.html',
  styleUrl: './component.component.sass'
})
export class ComponentComponent implements OnInit {
  components: Components[] = [];
  descSort = ClrDatagridSortOrder.DESC;
  activeState: boolean = true;
  loading: boolean = true;

  constructor(
    private compss: ComponentsStoreService,
    private route: ActivatedRoute,
    public alertDispatcher: AlertService
  ) {
    ClarityIcons.addIcons(twoWayArrowsIcon, nodeIcon, cogIcon);
  }

  ngOnInit(): void {
    const params = this.route.snapshot.paramMap;
    this.activeState = params.get('active') === "true";
    this.getComponents(this.activeState);
  }

  private getComponents(active: boolean) {
    this.compss.getComponents(active).subscribe({
      next: data => {
        if (!data || !data.object || data.object.length === 0) {
          this.alertDispatcher.show({
            message: ' Keine Komponenten gefunden! ',
            clrAlertType: IAlertType.WARNING
          }, 2000);
        }
        this.components = data.object;
      },
        complete: () => {
          this.loading = false;
        },
        error: () => {
          return
        }
    })
  }
}
